import { createStore, randomStringGenerator } from '@helpers/utils';

export const initialState = {
    id: null,
    isEdit: false,
    isEditCustomer: false,
    sku_list: [],
    customer_list: [],
    upload_token: randomStringGenerator(),
    isCanEdit: true,

    searchSku: null,
    searchMasterDataSku: null,
    searchCustomer: null,
    searchMasterDataCustomer: null,
    limit: 10,
    page: 1,
    total_page: 1,
    total_data: 0,
};

export const useEditDetail = createStore(initialState);
